import React, { useState, useEffect } from "react";
import "./BanAgendamentos.css";
import "aos/dist/aos.css";

const Agendamento = () => {
  const [backgroundImage, setBackgroundImage] = useState('/images/banner-agendamento/leaf.svg');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setBackgroundImage('/images/banner-agendamento/leaf.png');
      } else if (width <= 1024) {
        setBackgroundImage('/images/banner-agendamento/leaf.svg');
      } else {
        setBackgroundImage('/images/banner-agendamento/leaf.svg');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="parallax-container banner-agendamento">
      <div
        className="fundo-agendamento"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          objectFit: 'auto',
          opacity: '0.15',
        }}
      ></div>
      <div className="banner-text-agendamento">
        <p className="paragrafo-1">Agende sua consulta</p>
        <p className="texto-convidativo">
          Conheça um atendimento que une técnica, sensibilidade e atenção
          individualizada para elevar sua autoestima com naturalidade e
          confiança.
        </p>
        <div className="container-btn">
          <a
            href="https://api.whatsapp.com/send/?phone=5561986253859&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            id="btn-contato"
            className="custom-btn"
          >
            Agende aqui
          </a>
        </div>
      </div>
    </div>
  );
};

export default Agendamento;